import script from "./ShoppingCartPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingCartPanel.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingCartPanel.vue?vue&type=style&index=0&id=4f1aa0bc&scoped=true&lang=css"
import "./ShoppingCartPanel.vue?vue&type=style&index=1&id=4f1aa0bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f1aa0bc"]])

export default __exports__